import React from 'react';
import { Box, CssBaseline, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { backdropImageUrl } from '@paragon/client-tools';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';

import { Account } from './Account';
import { AccountVerification } from './AccountVerification';
import { AuthorizeApiAccess } from './AuthorizeApiAccess';
import { Home } from './Home';
import { ServicesLogin } from './ServicesLogin';
import { ServicesResetPassword } from './ServicesResetPassword';
import { ServicesSignUp } from './ServicesSignUp';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <ServicesLogin />,
  },
  {
    path: '/signup',
    element: <ServicesSignUp />,
  },
  {
    path: '/resetpassword',
    element: <ServicesResetPassword />,
  },
  {
    path: '/verifyAccount',
    element: <AccountVerification />,
  },
  {
    path: '/api/authorize',
    element: <AuthorizeApiAccess />,
  },
  {
    path: '/account',
    element: <Account />,
  },
]);

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': { color: 'white' },
}));

function RootComponent() {
  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        maxSnack={3}
        Components={{
          default: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            position: 'fixed',
            backgroundImage: `url(${backdropImageUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundAttachment: 'fixed',
            top: 0,
          }}
        >
          <Notifier />
          <NotifierDialog />
          <RouterProvider router={router} />
        </Box>
      </SnackbarProvider>
    </>
  );
}

export default RootComponent;
